(() => {
  'use strict';

  const isZeroNicotineVariant = (variant) => {
    if (!variant) return false;
    const values = [variant.title, ...(variant.options || [])]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '');

    // Ne jamais utiliser `includes('0mg')` ici : « 10mg » et « 20mg »
    // contiennent eux aussi cette chaîne et étaient donc pris pour du 0 mg.
    return values.includes('sansnicotine')
      || /(^|[^0-9])0(?:mg(?:\/ml)?|%)(?:$|[^0-9])/.test(values);
  };

  const variantFromPicker = (root) => {
    const source = root.querySelector('variant-selects [data-selected-variant]');
    if (!source?.textContent?.trim()) return null;

    try {
      return JSON.parse(source.textContent);
    } catch (_error) {
      return null;
    }
  };

  const updateSafety = (root, variant) => {
    const nicotineWarning = root.querySelector('[data-cc-nicotine-warning]');
    const zeroWarning = root.querySelector('[data-cc-zero-warning]');
    if (!nicotineWarning || !zeroWarning || !variant) return;

    const isZero = isZeroNicotineVariant(variant);
    nicotineWarning.classList.toggle('is-hidden', isZero);
    zeroWarning.classList.toggle('is-hidden', !isZero);

    const stock = root.querySelector('[data-cc-stock]');
    const stockText = stock?.querySelector('[data-cc-stock-text]');
    if (stock && stockText) {
      stock.classList.toggle('is-sold-out', !variant.available);
      stockText.textContent = variant.available ? 'En stock' : 'Rupture de stock';
    }
  };

  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    return String(format || '{{ amount_with_comma_separator }} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  };

  const updateStickyBuy = (sectionId, variant) => {
    const bar = document.querySelector(`[data-cc-sticky-buy][data-product-section="${sectionId}"]`);
    if (!bar || !variant) return;

    const variantInput = bar.querySelector('[data-cc-sticky-variant-id]');
    const variantLabel = bar.querySelector('[data-cc-sticky-variant-label]');
    const price = bar.querySelector('[data-cc-sticky-price]');
    const submit = bar.querySelector('[data-cc-sticky-submit]');

    if (variantInput) variantInput.value = variant.id;
    if (variantLabel) variantLabel.textContent = variant.options?.[0] || variant.title;
    if (price) price.textContent = formatMoney(variant.price, bar.dataset.moneyFormat);
    if (submit) {
      submit.disabled = !variant.available;
      const label = submit.querySelector('[data-cc-sticky-submit-label]');
      if (label) label.textContent = variant.available ? 'Ajouter' : 'Indisponible';
    }
  };

  const initStickyBuy = () => {
    document.querySelectorAll('[data-cc-sticky-buy]').forEach((bar) => {
      if (bar.dataset.ccStickyInit === 'true') return;
      bar.dataset.ccStickyInit = 'true';

      const input = bar.querySelector('[data-cc-sticky-quantity]');
      bar.querySelector('[data-cc-sticky-minus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      bar.querySelector('[data-cc-sticky-plus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = Number(input.value || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  const init = () => {
    document.querySelectorAll('product-info[data-eliquid-template]').forEach((root) => {
      if (root.dataset.ccEliquidInit === 'true') return;
      root.dataset.ccEliquidInit = 'true';

      const stickyBar = document.querySelector('[data-cc-sticky-buy]');
      if (stickyBar) stickyBar.dataset.productSection = String(root.dataset.section);

      // Recalage initial sur la variante réellement sélectionnée.
      const initialVariant = variantFromPicker(root);
      if (initialVariant) updateSafety(root, initialVariant);

      // Les 50 ml classiques utilisent un choix 0 / 3 / 6 mg indépendant des
      // variantes Shopify afin d'ajouter automatiquement les boosters.
      document.addEventListener('cc:booster:changed', ({ detail }) => {
        const mode = String(detail?.mode || '0mg');
        updateSafety(root, { title: mode, options: [mode], available: true });
      });

      // Filet de sécurité pour les sélecteurs de variantes 10/20 mg : la mise
      // à jour principale reste l'événement Shopify ci-dessous, mais ce rappel
      // évite un état figé si un thème/app intercepte temporairement l'événement.
      root.addEventListener('change', (event) => {
        if (!event.target.closest('variant-selects')) return;
        window.setTimeout(() => {
          const currentVariant = variantFromPicker(root);
          if (currentVariant) updateSafety(root, currentVariant);
        }, 0);
      });

      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data?.variant || String(data.sectionId) !== String(root.dataset.section)) return;
        updateSafety(root, data.variant);
        updateStickyBuy(String(root.dataset.section), data.variant);
      });
    });

    initStickyBuy();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
